// src/App.jsx
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App as AntApp, theme as antdTheme } from 'antd';
import { IntlProvider } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import CookieBanner from './components/common/CookieBanner';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';
import { MESSAGES } from './lib/i18n';
import { CartProvider } from './context/CartContext'
function ThemedApp() {
    const { isDark, isRtl, locale } = useTheme();
    // Inside a new component rendered under AuthProvider
    // function MaintenanceGate({ children }) {
    //     const { isAdmin } = useAuth();
    //     const [settings, setSettings] = useState(null);

    //     useEffect(() => {
    //         fetchSettings().then(setSettings).catch(() => { });
    //     }, []);

    //     if (!settings) return children;

    //     if (settings.maintenance_mode && !isAdmin) {
    //         return (
    //             <div className="errpage">
    //                 <div className="inner">
    //                     <div className="icon is-forbidden"><ToolOutlined /></div>
    //                     <h1>Maintenance</h1>
    //                     <p className="sub">{settings.maintenance_message}</p>
    //                 </div>
    //             </div>
    //         );
    //     }

    //     return children;
    // }
    return (
        <IntlProvider
            locale={locale}
            defaultLocale="en"
            messages={MESSAGES[locale]}
            onError={(err) => {
                // Silence noisy missing-translation warnings in dev
                if (err.code === 'MISSING_TRANSLATION') return;
                // eslint-disable-next-line no-console
                console.error(err);
            }}
        >
            <ConfigProvider
                direction={isRtl ? 'rtl' : 'ltr'}
                theme={{
                    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                    token: {
                        colorPrimary: '#1677ff',
                        borderRadius: 8,
                        fontFamily: isRtl
                            ? "'Vazirmatn', 'Tahoma', 'Inter', sans-serif"
                            : "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    },
                }}
            >
                <AntApp>
                    <BrowserRouter>
                        <AuthProvider>
                            <CartProvider>
                                <AppRoutes />
                                <ToastContainer
                                    position={isRtl ? 'top-left' : 'top-right'}
                                    autoClose={3000}
                                    theme={isDark ? 'dark' : 'light'}
                                />
                            </CartProvider>
                        </AuthProvider>
                        <CookieBanner />
                    </BrowserRouter>
                </AntApp>
            </ConfigProvider>
        </IntlProvider>
    );
}

export default function App() {
    return (
        <ThemeProvider>
            <ThemedApp />
        </ThemeProvider>
    );
}